import { AuthModel } from "./auth.model";

export class UserModel extends AuthModel {
    id: string;
    username: string;
    nric:string;
    password: string;
    name: string;
    email: string;
    accountStatus: string;
    profileImage: string;
    roles: number[] = [];
    occupation: string;
    companyName: string;
    phoneNumber: string;
    // account information
    language: string;
    memberId: number;
   // officeId: any;
    city: string;
    officeId: number;
    setUser(_user: unknown) {
      const user = _user as UserModel;
      this.id = user.id;
      this.nric = user.nric;
      this.username = user.username || '';
      this.password = user.password || '';
      this.name = user.name || '';
      this.email = user.email || '';
      this.profileImage = user.profileImage || './assets/images/profile-placeholder.png';
      this.roles = user.roles || [];
      this.occupation = user.occupation || '';
      this.companyName = user.companyName || '';
      this.phoneNumber = user.phoneNumber || '';
      this.memberId = user.memberId;
      this.accountStatus = user.accountStatus;
      this.city = user.city || '';
      this.officeId = user.officeId || 0;
    }

}
